export const NAME_DROPDOWN_CAP = 200;

export function nameLookupCaps(dimension: string): Record<string, number> {
  return { [dimension]: NAME_DROPDOWN_CAP };
}
